import { html } from "htm/preact/index.js";

/**
 * @typedef {object} QueryFormSimpleRadioProps
 * @property {import("preact").ComponentChildren} children
 * @property {boolean} disabled
 * @property {() => void} onClick
 * @property {string} name
 * @property {string} theme
 * @property {string} value
 */

/**
 * @param {QueryFormSimpleRadioProps} props
 * @returns {import("preact").VNode}
 */
function QueryFormSimpleRadio({
  children,
  disabled,
  onClick,
  theme = "primary",
  name,
  value,
}) {
  return html`<label class="btn" data-theme=${theme} onClick=${onClick}>
    <span class="btn__label">${children}</span>
    <input
      required
      type="radio"
      disabled=${disabled}
      name=${name}
      value=${value}
    />
  </label>`;
}

export default QueryFormSimpleRadio;
